export const faqTitlesDict = {
  ru: 'Часто задаваемые вопросы',
  de: 'Häufig gestellte Fragen',
  en: 'Frequently asked questions',
  tr: 'Sıkça Sorulan Sorular',
  es: 'Preguntas frecuentes',
};

// Accessibility messages for FAQ components
export const faqAccessibilityMessages = {
  en: {
    expandAnswer: 'Expand answer',
  },
  ru: {
    expandAnswer: 'Развернуть ответ',
  },
  de: {
    expandAnswer: 'Antwort erweitern',
  },
  tr: {
    expandAnswer: 'Cevabı genişlet',
  },
  es: {
    expandAnswer: 'Expandir respuesta',
  },
};
